import { render } from "./StationPassportChangeRecord.vue?vue&type=template&id=ca814b94"
import script from "./StationPassportChangeRecord.vue?vue&type=script&lang=js"
export * from "./StationPassportChangeRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__